import { useAuth } from '@/lib/auth';
import { protectedRoutes } from './protected';
import { publicRoutes } from './public';
import { useRoutes ,Navigate} from 'react-router-dom';

export const AppRoutes = () => {
  const { user, loading } = useAuth();

  const routes = user
    ? [...protectedRoutes, ...publicRoutes]
    : [
        ...publicRoutes,
        { path: '/app/*', element: <Navigate to="/auth/login" replace /> },
      ];

  const rootRoute = {
    path: '/',
    element: user ? <Navigate to="/app" replace /> : <Navigate to="/auth/login" replace />,
  };

  const element = useRoutes([...routes, rootRoute]);

  return loading ? <div /> : element;
};